// src/components/modals/CreativeUnblockModal.js
import React from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';
import useTypewriter from '../../hooks/useTypewriter';
import { CloseIcon, SparklesIcon } from '../ui/Icons';
import FormattedSuggestion from '../task-details/FormattedSuggestion';

const CreativeUnblockModal = ({ isOpen, onClose, task, suggestion, isLoading }) => {
    const displayText = useTypewriter(suggestion, 20);
    if (!isOpen) return null;
    return (
        <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-2xl">
            <div className="p-6 border-b border-white/20 flex justify-between items-center bg-gradient-to-r from-gray-800 to-gray-800/50 rounded-t-2xl">
                <div>
                    <h2 className="text-2xl font-bold text-white">Desbloqueio Criativo</h2>
                    <p className="text-sm text-gray-300 mt-1">Sugestões para a tarefa: "{task.title}"</p>
                </div>
                <button onClick={onClose} className="text-gray-400 hover:text-white">
                    <CloseIcon size={24} />
                </button>
            </div>
            <div className="p-8 space-y-4 text-left text-gray-200 max-h-[60vh] overflow-y-auto">
                {isLoading ? (
                    <div className="flex flex-col items-center justify-center h-40">
                        <SparklesIcon className="animate-pulse text-indigo-400" size={48} />
                        <p className="mt-4 text-lg">Buscando inspiração...</p>
                    </div>
                ) : (
                    <FormattedSuggestion text={displayText} />
                )}
            </div>
            <div className="p-6 flex justify-end space-x-4 bg-black/20 rounded-b-2xl">
                <GlassButton onClick={onClose}>
                    Fechar
                </GlassButton>
            </div>
        </Modal>
    );
};

export default CreativeUnblockModal;